export const HTTP_ERROR = 'Ha ocurrido un error, intente mas tarde.'
